module.exports = __webpack_public_path__ + "img/ch33.b75975b0.png";